import { useState } from 'react';
import { t } from 'i18next';

import Button from '../shared/Button';
import View from '../shared/View';

import './ChangeSchool.scss';
import LabeledSelect from '../shared/LabeledSelect';
import FileDrop from '../shared/FileDrop';
import { Box, Dialog, DialogContent, DialogTitle } from '@mui/material';

export default function ChangeSchool(props) {
    const [letter] = useState([]);

    let viewTitle = (
        <h2>
            <span>{t('ChangeSchool.Header')}</span>
        </h2>
    );

    return (
        <View
            doingAjax={false}
            name="change-school"
        >
            <Dialog open={true}>
                <DialogTitle>{viewTitle}</DialogTitle>
                <DialogContent>
                    <Box className="change-school-body">
                        <div className="change-school-instructions">{t('ChangeSchool.Instructions')}</div>

                        <div>
                            <LabeledSelect labelText={t('ChangeSchool.SelectLabel')} />
                        </div>

                        <div>
                            <FileDrop files={letter} />
                        </div>
                    </Box>
                    <Box>
                        <Button
                            useMui={true}
                            defaultText={t('General.Cancel')}
                            type="grey"
                            onClick={() => (typeof props.close === 'function' ? props.close() : null)}
                            interactive={false}
                        />
                        <Button
                            useMui={true}
                            defaultText={t('ChangeSchool.UpdateButton')}
                            onClick={() => (typeof props.close === 'function' ? props.close() : null)}
                            interactive={false}
                        />
                    </Box>
                </DialogContent>
            </Dialog>
        </View>
    );
}
